import React from 'react';

import { createRoot } from 'react-dom/client';

import { loadConfig } from './config/config';
import { getAppAuthentication } from './modules/main/util/get-app-authentication';

import './styles/base.scss';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
function renderSite(Main: typeof import('./modules/main/main').Main) {
  const container = document.getElementById('root');

  if (!container) {
    throw new Error('Could not boostrap application as container element is missing.');
  }

  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <Main />
    </React.StrictMode>,
  );
}

loadConfig()
  .then(() => Promise.all([import('./modules/main/main'), getAppAuthentication()]))
  .then(([mainModule]) => renderSite(mainModule.Main));
